import { render, staticRenderFns } from "./groupContent.vue?vue&type=template&id=bc066e12&scoped=true"
import script from "./groupContent.vue?vue&type=script&lang=js"
export * from "./groupContent.vue?vue&type=script&lang=js"
import style0 from "./groupContent.vue?vue&type=style&index=0&id=bc066e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc066e12",
  null
  
)

export default component.exports